module.exports = __webpack_public_path__ + "static/media/A_Quiet_Thought.bc8f0384.mp3";